export const dealerLocatorConfig = {
    map: {
      zoomLevel: 10,
      rankIconUrlPattern: '../content/dam/gmownercenter/gmna/static/siteImages/icons/google-icons/marker-icons/marker{rank}.png'
    },
    preferredDealer: {
      saveSuccessTimeout: 5000
    }
  };
